import { flowRight } from 'lodash';
import React from 'react';
import { ISignee } from './interfaces';
import SigneeActionIcon from './PortalSigneeActionIcon';
import {
  SigneeActionDate,
  SigneeActionDateContainer,
  SigneeActionText,
  SigneeActionTitle,
} from './PortalSigneesList.styles';
import { t } from 'i18next';

interface ISigneeAction {
  actionDateTime: ISignee['actionDateTime'];
  actionRole: ISignee['actionRole'];
}

const SigneeAction = ({ actionRole, actionDateTime }: ISigneeAction) => {
  return (
    <div>
      <SigneeActionTitle actionRole={actionRole}>
        <SigneeActionText>
          {flowRight(
            t,
            getActionText
          )(actionRole)}
        </SigneeActionText>
        <SigneeActionIcon actionRole={actionRole} />
      </SigneeActionTitle>
      <SigneeActionDateContainer>
        <SigneeActionDate>{actionDateTime}</SigneeActionDate>
      </SigneeActionDateContainer>
    </div>
  );
};

const getActionText = (actionRole: ISignee['actionRole']): string => {
  return actionRole === 'Signee'
    ? 'Signed'
    : actionRole === 'Rejector'
    ? 'Rejected'
    : '';
};

export default SigneeAction;
